module.exports = __webpack_public_path__ + "img/iso_menu.9bd1235b.png";